import React, {useEffect, useRef} from 'react';
import {Box, TextField} from "@mui/material";


export default function ({values, errors, handleChange, handleBlur}: any) {

    const textField1Ref = useRef<HTMLInputElement>(null)
    useEffect(() => {
        const handleWheel = (e: WheelEvent) => e.preventDefault()
        textField1Ref.current?.addEventListener('wheel', handleWheel)

        return () => {
            if (textField1Ref.current) {
                textField1Ref.current.removeEventListener('wheel', handleWheel)
            }
        }
    }, [])
    const textField2Ref = useRef<HTMLInputElement>(null)
    useEffect(() => {
        const handleWheel = (e: WheelEvent) => e.preventDefault()
        textField2Ref.current?.addEventListener('wheel', handleWheel)

        return () => {
            if (textField2Ref.current) {
                textField2Ref.current?.removeEventListener('wheel', handleWheel)
            }
        }
    }, [])

    return <Box display={"flex"}>
        <TextField
            id={`Quantity`}
            name={`Quantity`}
            label={"Izdelano"}
            type={"number"}
            sx={{width: "50%", mr: "0.5em"}}
            value={values.Quantity}
            onChange={handleChange}
            slotProps={{input:{sx: {fontSize: "2em"}}}}
            onBlur={handleBlur}
            ref={textField1Ref}
            error={Boolean(errors.Quantity)}
            helperText={errors.Quantity && errors.Quantity}
        />
        <TextField
            id={`ScrapQuantity`}
            name={`ScrapQuantity`}
            label={"Izmet"}
            type={"number"}
            ref={textField2Ref}
            sx={{width: "50%", ml: "0.5em"}}
            value={values.ScrapQuantity}
            onBlur={handleBlur}
            onChange={handleChange}
            slotProps={{input:{sx: {fontSize: "2em"}}}}
            error={Boolean(errors.ScrapQuantity)}
            helperText={errors.ScrapQuantity &&  errors.ScrapQuantity}
        />
    </Box>
}
